import React, { useState, useEffect, useContext, useMemo } from "react"

// TODO: Switch to use the shared component lib modal
import MbModal from "~components/shared/mb-modal"
import FormControl from "~components/shared/todo-lib-react-components/form-control"
import PrimaryGradientButton from "~components/shared/primary-gradient-button"
import { UserContext } from "~config/user-provider"
import { validatePhoneNumber } from "~utils/helpers"
import PhoneNumberInput from "~components/shared/form-inputs/phone-number-input"
import COPY from "~config/copy-constants"
import Input from "~components/shared/todo-lib-react-components/input"

function WelcomeModal() {
    const [isOpen, setIsOpen] = useState(false)
    const { user, updateUser, setUserNewData, isUpdating } =
        useContext(UserContext)
    const [firstName, setFirstName] = useState<string>(user?.first_name || "")
    const [lastName, setLastName] = useState<string>(user?.last_name || "")
    const [phoneNumber, setPhoneNumber] = useState<string>(user?.phone || "")

    useEffect(() => {
        if (user) {
            setFirstName(user.first_name || "")
            setLastName(user.last_name || "")
            setPhoneNumber(user.phone || "")
            setIsOpen(!user.first_name || !user.last_name || !user.phone)
        }
    }, [user, setIsOpen])

    useEffect(() => {
        if (isOpen) {
            setUserNewData({
                first_name: firstName,
                last_name: lastName,
                phone: phoneNumber,
            })
        }
    }, [firstName, isOpen, lastName, phoneNumber])

    const isInputValid = useMemo(
        () =>
            firstName !== "" &&
            lastName !== "" &&
            phoneNumber !== "" &&
            validatePhoneNumber(phoneNumber),
        [firstName, lastName, phoneNumber]
    )

    return (
        <MbModal
            title={COPY.LET_US_GET_TO_KNOW_YOU}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            allowClose={false}
        >
            <FormControl label="First name*" caption="">
                <Input
                    id="first-name-input"
                    type="text"
                    value={firstName}
                    onChange={(value) => setFirstName(value)}
                />
            </FormControl>
            <FormControl label="Last name*" caption="">
                <Input
                    id="last-name-input"
                    type="text"
                    value={lastName}
                    onChange={(value) => setLastName(value)}
                />
            </FormControl>
            <PhoneNumberInput
                id="phone-number-input"
                label={COPY.PHONE_LABEL}
                caption={COPY.PHONE_CAPTION}
                value={phoneNumber}
                onChange={setPhoneNumber}
            />
            <PrimaryGradientButton
                fullwidth
                onClick={() => {
                    updateUser({
                        onCompleted: () => setIsOpen(false),
                    })
                }}
                isLoading={isUpdating}
                isDisabled={!isInputValid}
            >
                {COPY.SAVE_AND_CONTINUE_EXPLORING}
            </PrimaryGradientButton>
        </MbModal>
    )
}

export default WelcomeModal
